import ChallengeEditor from './ChallengeEditor';

export default ChallengeEditor;
